<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <form [formGroup]="supplierForm" (ngSubmit)="isCreating ? createSupplier() : updateSupplier()" *ngIf="supplier">
    <page-header
      [icon]="'far-truck'"
      [title]="isCreating ? 'supplier.new' : 'supplier'"
      [appendNoTranslationTitlePart]="supplier ? supplier.name : ''"
    >
      <ng-container class="header-button">
        <btn
          [btnType]="'submit'"
          [icon]="'far-check'"
          [classes]="['btn-first', 'float-right']"
          [label]="'save'"
          [title]="'save' | translate"
          [isLoading]="loading"
          [btnDisabled]="loading"
          [spinnerClassesString]="'spinner-white'"
          data-cy="create-supplier"
        ></btn>
        <btn
          *ngIf="!isCreating && supplier?.deletable"
          [btnType]="'button'"
          [classes]="['btn-first-red', 'float-right', isCreating ? '' : 'mr-2']"
          (onEvent)="deleteSupplier()"
          [icon]="'far-trash-alt'"
          [label]="'delete'"
          [title]="'delete' | translate"
          data-cy="delete-supplier"
        ></btn>
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'mr-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="navigateBack()"
        ></btn>
      </ng-container>
    </page-header>

    <section class="content">
      <div class="card">
        <div class="row">
          <div class="col-sm-6">
            <form-row-input
              [formGroup]="supplierForm"
              formControlName="name"
              [required]="supplierForm.get('name').errors !== null && supplierForm.get('name').errors.required"
              [requiredCssClass]="submitted && formControls.name.errors"
              [label]="'supplier.name'"
              [icon]="'far-list'"
              data-cy="name"
            ></form-row-input>
          </div>
        </div>
      </div>
    </section>
  </form>
</div>
